import EF from 'ef/ef';
import View from 'views/base/view';
import CourseModuleTemplate from './templates/course-module';

const GRANT_MODIFIER = 'grant';
const REMOVE_MODIFIER = 'remove';

const CourseModuleView = View.extend({
  template: CourseModuleTemplate,
  className: 'card',
  listen: {
    addedToParent: 'loaded',
  },
  loaded: function () {
    const pageProgressHandler = (event, modifier) => {
      const button = event.currentTarget;
      const mod = EF.modules.find({
        key: button.attributes['data-module'].value,
      });
      const act = mod.activities.find({
        key: button.attributes['data-activity'].value,
      });
      const page = act.pages.find({ key: button.attributes['data-page'].value });
      if (modifier === GRANT_MODIFIER) {
        page.set('completed', true);
      }

      if (modifier === REMOVE_MODIFIER) {
        mod.currentActivity = act;
        const prevPage = mod.getPreviousPageByKey(page.get('key'));
        mod.clearProgress();
        if (prevPage) {
          prevPage.set('completed', true);
        }
      }

      this.wasOpen = true;
      EF.ContentProvider.CourseModuleService.saveModuleProgress(this, page, mod);
    };

    const moduleProgressHandler = (event, modifier) => {
      this.wasOpen = this.$('.collapse').hasClass('show');
      const mod = EF.modules.find({
        key: event.currentTarget.attributes['data-module'].value,
      });
      if (modifier === GRANT_MODIFIER) {
        mod.completeAllPages();
        EF.ContentProvider.CourseModuleService.saveModule(mod);
      }

      if (modifier === REMOVE_MODIFIER) {
        mod.clearProgress();
        mod.save();
      }

      this.render();
    };

    this.delegate('click', '.btn-progress.bg-color-success-base', function (e) {
      pageProgressHandler(e, GRANT_MODIFIER);
    });
    this.delegate('click', '.btn-progress.bg-color-error-base', function (e) {
      pageProgressHandler(e, REMOVE_MODIFIER);
    });
    this.delegate('click', '.progress-grant-all', function (e) {
      moduleProgressHandler(e, GRANT_MODIFIER);
    });
    this.delegate('click', '.progress-remove-all', function (e) {
      moduleProgressHandler(e, REMOVE_MODIFIER);
    });
  },
  getTemplateData: function () {
    const data = this.model.serialize();
    data.wasOpen = this.wasOpen;
    data.local = EF.options.local;
    return data;
  },
});

export default CourseModuleView;
